const SET_COMMENTS = "SET_COMMENTS";
const SEND_COMMENTS = "SEND_COMMENTS";
const GET_COMMENTS = "GET_COMMENTS";

export { SET_COMMENTS, SEND_COMMENTS, GET_COMMENTS };
